module.exports = __webpack_public_path__ + "media/images/ohap_ui_plus_outline_on-97ffc3eb36426cf8d4a7c4713957fc45.png";